import { useMantineTheme } from '@mantine/core'
import React from 'react'

type ExternalLinkProps = {
  children: React.ReactNode
  href: string
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

export const ExternalLink = ({ children, href, ...restOfProps }: ExternalLinkProps) => {
  const theme = useMantineTheme()

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      css={{
        backgroundColor: 'transparent',
        border: 'none',
        color: theme.colors.primary[0],
        fontSize: theme.fontSizes.sm,
        fontWeight: '600',
        textDecoration: 'underline',
      }}
      {...restOfProps}
    >
      {children}
    </a>
  )
}
